export enum PageTypeEnum {
  Devices = 'DEVICES',
  Purchases = 'PURCHASES',
  EmployeeDetails = 'EMPLOYEE_DETAILS',
  Overview = 'OVERVIEW',
  PhonePlans = 'PHONE_PLANS',
  Orders = 'ORDERS',
}
